module.exports = __webpack_public_path__ + "static/media/top-brand-44.7c42e9ce.png";